import { render, staticRenderFns } from "./AddonProduct.vue?vue&type=template&id=da15919e&scoped=true&"
import script from "./AddonProduct.vue?vue&type=script&lang=js&"
export * from "./AddonProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddonProduct.vue?vue&type=style&index=0&id=da15919e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da15919e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da15919e')) {
      api.createRecord('da15919e', component.options)
    } else {
      api.reload('da15919e', component.options)
    }
    module.hot.accept("./AddonProduct.vue?vue&type=template&id=da15919e&scoped=true&", function () {
      api.rerender('da15919e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/AddonProduct.vue"
export default component.exports